import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { ApiRequestGet } from "../../../../data/network/services/ApiRequestGet";
import {
  clearGlobalFilterReducer,
  globalFilterReducer,
} from "../../../../data/redux/slice/globalFiltersSlice";
import {
  fetchClientDropDownList,
  fetchResellerDropDownList,
  fetchResellerServiceProviderDropDownList,
  fetchServiceProviderDropDownList,
} from "../../../../services/fetchDropdownListData";
import {
  fetchClientBalance,
  fetchVanCustomer,
  fetchVanTransaction,
  getAllDashboardTransactionCount,
  getAllDashboardVolumeCount,
  getAllSettlementCount,
  updateMainTransactions,
} from "../../../../services/fetchListingData";
import secureStorage from "../../../../services/secureStorage";
import {
  SS_INTERNAL,
  SS_ROLE,
  SS_USER_HASH_ID,
} from "../../../../utility/constants/secureStorageManager";
import {
  CLIENT,
  RESELLER,
  SALES,
  STATUS_CODE_200,
  TRANSACTION_CREDITED,
  TRANSACTION_DEBITED,
  TRANSACTION_DEEMED,
  TRANSACTION_FAILED,
  TRANSACTION_PENDING,
  TRANSACTION_REJECTED,
} from "../../../../utility/constants/valueConstants";
import { CustomButton } from "../../main_comps/custom_button";
import CustomDatePicker from "../../main_comps/custom_date_picker";
import { CustomInput } from "../../main_comps/custom_input/CustomInput";
import CustomSelect from "../../main_comps/custom_select";

const GlobalFilters = ({
  onClickFilterCall,
  close,
  currentServiceType = "",
}) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const role = secureStorage.getItem(SS_ROLE);
  const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  const internal = secureStorage.getItem(SS_INTERNAL);
  const filters = useSelector((state) => state.globalFiltersSlice);
  const serviceProvider = useSelector(
    (state) => state.dropDownListSlice.serviceProviderNameList
  );
  const clientList = useSelector((state) => state.dropDownListSlice.clientList);
  const resellerList = useSelector(
    (state) => state.dropDownListSlice.resellerList
  );
  const location = useLocation();
  const [fromDate, setFromDate] = useState(filters?.fromDate);
  const [toDate, setToDate] = useState(filters?.toDate);
  const [selectedReseller, setSelectedReseller] = useState(filters?.resellerId);
  const [selectedClient, setSelectedClient] = useState(filters?.clientId);
  const [selectedServiceProvider, setSelectedServiceProvider] = useState(
    filters?.serviceProvider
  );

  const [custRefNo, setCustRefNo] = useState(filters?.custRefNo);
  const [transactionId, setTransactionId] = useState(filters?.transactionId);
  const [van, setVan] = useState(filters?.van);
  const [bankUTR, setBankUTR] = useState(filters?.bankUTR);
  const [mobileNumber, setMobileNumber] = useState(filters?.mobileNumber);
  const [upi, setUpi] = useState(filters?.upi);
  const [email, setEmail] = useState(filters?.email);

  const [selectedServiceType, setSelectedServiceType] = useState(
    filters?.serviceType
  );

  const [selectedStatus, setSelectedStatus] = useState(filters?.status);
  const inputStyle = {
    backgroundColor: "#F3F3F3",
    alignSelf: "center",
    height: 50,
    width: "100%",
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    borderRadius: 5,
    boxSizing: "border-box",
  };
  const containerStyle = {
    padding: 0,
    height: 50,
    marginBottom: 20,
  };
  const serviceTypeOptions = [
    { label: "Payin", value: "payin" },
    { label: "Payout", value: "payout" },
    { label: "Van", value: "van" },
    { label: "Voucher", value: "voucher" },
    { label: "van-upi", value: "van-upi" },
  ];

  const settlementStatusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Settled",
      value: "SETTLED",
    },
    {
      label: "Failed",
      value: "FAILED",
    },
    {
      label: "Initiated",
      value: "INITIATED",
    },
  ];
  const statusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Active",
      value: "ACTIVE",
    },
    {
      label: "In-Active",
      value: "INACTIVE",
    },
  ];
  const VanstatusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Active",
      value: true,
    },
    {
      label: "In-Active",
      value: false,
    },
  ];

  const TransactionStatusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Success",
      value: TRANSACTION_CREDITED,
    },
    {
      label: "Initiated",
      value: TRANSACTION_PENDING,
    },
    {
      label: "Failed",
      value: TRANSACTION_FAILED,
    },
    {
      label: "Debited",
      value: TRANSACTION_DEBITED,
    },
    {
      label: "Rejected",
      value: TRANSACTION_REJECTED,
    },
    {
      label: "Deemed",
      value: TRANSACTION_DEEMED,
    },
  ];
  const VanTransactionStatusOptions = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Success",
      value: "SUCCESS",
    },
    {
      label: "Initiated",
      value: TRANSACTION_PENDING,
    },
    {
      label: "Failed",
      value: "FAILED",
    },

    {
      label: "Debited",
      value: TRANSACTION_DEBITED,
    },
    {
      label: "Rejected",
      value: TRANSACTION_REJECTED,
    },
  ];
  const TransactionStatus = [
    {
      label: "None",
      value: "",
    },
    {
      label: "Success",
      value: "SUCCESS",
    },
    {
      label: "Initiated",
      value: TRANSACTION_PENDING,
    },
    {
      label: "Failed",
      value: "FAILED",
    },
  ];

  const customerStatusOption = [
    {
      label: "Active",
      value: true,
    },
    {
      label: "In-Active",
      value: false,
    },
  ];

  useEffect(() => {
    dispatch(fetchClientDropDownList(currentServiceType));

    dispatch(fetchResellerDropDownList());
    if (role?.toUpperCase() === RESELLER) {
      dispatch(fetchResellerServiceProviderDropDownList());
    } else {
      dispatch(fetchServiceProviderDropDownList());
    }
  }, []);

  // 30 days

  const calculateMaxDate = () => {
    if (fromDate) {
      const fromDateObject = new Date(fromDate);
      fromDateObject.setMonth(fromDateObject.getMonth() + 1);
      return fromDateObject.toISOString().split("T")[0];
    }
    return null;
  };
  const [maxDate, setMaxDate] = useState(null);

  useEffect(() => {
    const result = calculateMaxDate();
    setMaxDate(result);
  }, [fromDate]);

  return (
    <div
      style={{
        maxHeight: 500,
        overflow: "scroll",
        position: "relative",
      }}
      className="hide-scroll-bar"
    >
      {filters.filters.includes("dateRange") && (
        <>
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              From
            </label>
            <CustomDatePicker value={fromDate} onChange={setFromDate} />
          </div>
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              To
            </label>
            <CustomDatePicker
              value={toDate}
              onChange={setToDate}
              minDate={fromDate}
              maxDate={maxDate}
              disabled={fromDate ? false : true}
            />
          </div>
        </>
      )}

      {filters.filters.includes("clientName") &&
        role?.toUpperCase() !== CLIENT && (
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              Client
            </label>

            <CustomSelect
              value={selectedClient}
              options={clientList}
              onChange={(data) => {
                setSelectedClient(data);
              }}
              placeholder={"Select client"}
            />
          </div>
        )}

      {filters.filters.includes("client") && role?.toUpperCase() !== CLIENT && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Client
          </label>

          <CustomSelect
            placeholder={"Select client"}
            value={selectedClient}
            options={clientList}
            onChange={(data) => {
              setSelectedClient(data);
            }}
          />
        </div>
      )}

      {filters.filters.includes("custRefNo") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Customer UTR
          </label>
          <CustomInput
            value={custRefNo}
            onChange={(data) => setCustRefNo(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Customer UTR"
            validator=""
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}
      {filters.filters.includes("upi") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            UPI
          </label>
          <CustomInput
            value={upi}
            onChange={(data) => setUpi(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="UPI"
            validator="upi"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}
      {filters.filters.includes("email") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Email
          </label>
          <CustomInput
            value={email}
            onChange={(data) => setEmail(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Email"
            validator="email"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}
      {filters.filters.includes("mobileNumber") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Mobile Number
          </label>
          <CustomInput
            value={mobileNumber}
            onChange={(data) => setMobileNumber(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Mobile Number"
            validator="mobile"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}

      {filters.filters.includes("bankUTR") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Bank UTR
          </label>
          <CustomInput
            value={bankUTR}
            onChange={(data) => {
              setBankUTR(data);
            }}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Bank UTR"
            validator="alphaNum"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}

      {filters.filters.includes("transactionId") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Txn ID
          </label>

          <CustomInput
            value={transactionId}
            onChange={(data) => setTransactionId(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="Txn ID"
            validator="alphaNum"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}

      {filters.filters.includes("resellerName") &&
        role?.toUpperCase() !== RESELLER &&
        role?.toUpperCase() !== CLIENT && (
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              Reseller
            </label>

            <CustomSelect
              value={selectedReseller}
              options={resellerList}
              onChange={(data) => setSelectedReseller(data)}
              placeholder={"Select reseller "}
            />
          </div>
        )}

      {filters.filters.includes("serviceProvider") && internal && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Service Provider
          </label>

          <CustomSelect
            value={selectedServiceProvider}
            options={serviceProvider}
            onChange={(data) => {
              setSelectedServiceProvider(data);
            }}
            placeholder={"Select service provider"}
          />
        </div>
      )}

      {filters.filters.includes("serviceType") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Service Type
          </label>

          <CustomSelect
            value={selectedServiceType}
            options={serviceTypeOptions}
            onChange={(data) => setSelectedServiceType(data)}
            placeholder={"Select service type"}
          />
        </div>
      )}

      {filters.filters.includes("customerName") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Customer Name
          </label>

          <CustomSelect placeholder={"Customer Name"} />
        </div>
      )}
      {filters.filters.includes("vanNumber") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            VAN/UPI
          </label>
          <CustomInput
            value={van}
            onChange={(data) => setVan(data)}
            inputcomponentStyles={{ ...inputStyle }}
            placeholder="VAN/UPI"
            //validator="alphaNum"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
          />
        </div>
      )}

      {/* {filters.filters.includes("business") &&
        role?.toUpperCase() !== CLIENT && (
          <div style={{ marginTop: 20 }}>
            <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
              Business
            </label>

            <CustomSelect placeholder={"Business"} />
          </div>
        )} */}

      {filters.filters.includes("status") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={statusOptions}
            onChange={(data) => setSelectedStatus(data)}
            placeholder={"Status"}
          />
        </div>
      )}
      {filters.filters.includes("Vanstatus") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={VanstatusOptions}
            onChange={(data) => {
              setSelectedStatus(data);
            }}
            placeholder={"Status"}
          />
        </div>
      )}
      {filters.filters.includes("tansactionStatus") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={TransactionStatus}
            onChange={(data) => {
              setSelectedStatus(data);
            }}
            placeholder={"Status"}
          />
        </div>
      )}

      {filters.filters.includes("settlementStatus") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={settlementStatusOptions}
            onChange={(data) => setSelectedStatus(data)}
            placeholder={"Status"}
          />
        </div>
      )}

      {filters.filters.includes("transactionStatus") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={TransactionStatusOptions}
            onChange={(data) => setSelectedStatus(data)}
            placeholder={"Status"}
          />
        </div>
      )}

      {filters.filters.includes("customerStatus") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={customerStatusOption}
            onChange={(data) => setSelectedStatus(data)}
            placeholder={"Status"}
          />
        </div>
      )}

      {filters.filters.includes("VanTransactionStatusOptions") && (
        <div style={{ marginTop: 20 }}>
          <label style={{ marginBottom: 5, color: "#6C6B6B", fontSize: 14 }}>
            Status
          </label>

          <CustomSelect
            value={selectedStatus}
            options={VanTransactionStatusOptions}
            onChange={(data) => setSelectedStatus(data)}
            placeholder={"Status"}
          />
        </div>
      )}

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <CustomButton
          title="Reset Filter"
          backgroundColor="white"
          styles={{ width: 120, border: "1px solid #1E2234" }}
          textStyles={{ color: "#1E2234" }}
          onClick={() => {
            dispatch(
              fetchVanCustomer({
                clientHashId: role === CLIENT ? ss_id : "",
              })
            );
            dispatch(
              fetchVanTransaction({
                clientHashId: role === CLIENT ? ss_id : "",
              })
            );
            dispatch(clearGlobalFilterReducer());
            onClickFilterCall();
            setFromDate("");
            setToDate("");
            setSelectedClient("");
            setSelectedServiceProvider("");
            setCustRefNo("");
            setTransactionId("");
            setVan("");
            setBankUTR("");
            setEmail("");
            setMobileNumber("");
            setUpi("");
          }}
        />
        <CustomButton
          title="Filter"
          backgroundColor="#38369C"
          styles={{ width: 120, marginLeft: 30 }}
          onClick={() => {
            if (fromDate && !toDate) {
              enqueueSnackbar("Please select To Date", {
                variant: "error",
              });
              return;
            }
            if (location.pathname === "/dashboard") {
              dispatch(
                getAllSettlementCount({
                  dateRange:
                    fromDate && toDate
                      ? moment(fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(toDate).format("DD/MM/YYYY")
                      : "",
                  serviceType: selectedServiceType.value ?? "",
                  userId: selectedClient.value ?? "",
                  userRefId: selectedReseller.value ?? "",
                })
              );
              dispatch(
                updateMainTransactions({
                  clientId: selectedClient.value ?? "",
                  resellerId: selectedReseller.value ?? "",
                  rootReferenceId: "",
                })
              );
              dispatch(fetchClientBalance(selectedClient?.value));

              dispatch(
                getAllDashboardVolumeCount({
                  clientId: selectedClient.value ?? "",
                  resellerId: selectedReseller.value ?? "",
                  rootReferenceId: "",
                  dateRange:
                    fromDate && toDate
                      ? moment(fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(toDate).format("DD/MM/YYYY")
                      : "",
                })
              );
              dispatch(
                getAllDashboardTransactionCount({
                  clientId: selectedClient.value ?? "",
                  resellerId: selectedReseller.value ?? "",
                  rootReferenceId: "",
                  dateRange:
                    fromDate && toDate
                      ? moment(fromDate).format("DD/MM/YYYY") +
                        "-" +
                        moment(toDate).format("DD/MM/YYYY")
                      : "",
                })
              );
            } else {
              if (
                selectedStatus?.value === undefined &&
                selectedReseller?.value === undefined &&
                selectedClient?.value === undefined &&
                selectedServiceProvider?.value === undefined &&
                selectedServiceType?.value === undefined &&
                custRefNo === "" &&
                transactionId === "" &&
                bankUTR === "" &&
                van === "" &&
                fromDate === "" &&
                toDate === "" &&
                email === "" &&
                mobileNumber === "" &&
                upi === ""
              ) {
                enqueueSnackbar("Please select a field", {
                  variant: "error",
                });
                return;
              }

              onClickFilterCall({
                fromDate: fromDate,
                toDate: toDate,
                serviceProvider: selectedServiceProvider,
                serviceType: selectedServiceType,
                resellerId: selectedReseller,
                clientId: selectedClient,
                status: selectedStatus,
                custRefNo: custRefNo,
                transactionId: transactionId,
                van: van,
                bankUTR: bankUTR,
                email: email,
                mobileNumber: mobileNumber,
                upi: upi,
              });
            }
            dispatch(
              globalFilterReducer({
                fromDate: fromDate,
                toDate: toDate,
                serviceProvider: selectedServiceProvider,
                serviceType: selectedServiceType,
                resellerId: selectedReseller,
                clientId: selectedClient,
                status: selectedStatus,
                showFilterModal: false,
                custRefNo: custRefNo,
                transactionId: transactionId,
                van: van,
                bankUTR: bankUTR,
                email: email,
                mobileNumber: mobileNumber,
                upi: upi,
              })
            );
          }}
        />
      </div>
    </div>
  );
};

export default GlobalFilters;
